import { Link } from 'react-router-dom';
import content from '../content/siteContent.json';

const Footer = () => {
  const { footer } = content;

  return (
    <footer className="footer">
      <div className="footer__col">
        <p className="eyebrow">{footer.contactLabel}</p>
        <a href={`mailto:${footer.contactEmail}`} className="footer__link">{footer.contactEmail}</a>
      </div>
      <div className="footer__col">
        <p className="eyebrow">{footer.socialLabel}</p>
        <div className="footer__links">
          {footer.socialLinks.map((link) => (
            <a key={link.label} href={link.url} target="_blank" rel="noreferrer">{link.label}</a>
          ))}
        </div>
      </div>
      <div className="footer__col">
        <p className="eyebrow">{footer.legalLabel}</p>
        <div className="footer__links">
          {footer.legalLinks.map((link) => (
            <Link key={link.label} to={link.to}>{link.label}</Link>
          ))}
        </div>
      </div>
      <div className="footer__col footer__copy">{footer.copyright}</div>
    </footer>
  );
};

export default Footer;
